import classNames from 'classnames';
import { Heading, List } from 'yoso';
import { Translation } from '~/components/I18n';
import { useLand } from '~/components/Land/Land.hooks';
import { ZoneCard } from '~/components/Land/Zone/Card/ZoneCard';
import { useMember } from '~/components/Member/Member.hooks';
import styles from './LandZoneCardList.module.scss';

export interface LandZoneCardListProps {
  id: number;
}

export const LandZoneCardList = ({ id }: LandZoneCardListProps) => {
  const {
    data: { zoneList },
  } = useLand(id);
  const {
    data: { isLoggedIn },
  } = useMember();

  return (
    <div className={classNames(styles.root, { [styles.loggedIn]: isLoggedIn })}>
      <div className={styles.header}>
        <Heading className={styles.title}>
          <Translation name="citizen_land_detail_zonelist_title" />
        </Heading>
      </div>
      <List className={styles.list}>
        {zoneList.map((zone) => (
          <li key={zone.zoneId}>
            <ZoneCard landId={id} {...zone} />
          </li>
        ))}
      </List>
    </div>
  );
};
